var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcReaderSignal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 9.66667H12.6667V7.66667H11.6667V12.1667H3.66667V4.16667L8.16667 4.16622V3.16667H6.16667V1.16667H5.16667V3.16667H3.66667C3.40153 3.16693 3.14733 3.27237 2.95985 3.45985C2.77237 3.64733 2.66693 3.90153 2.66667 4.16667V5.66667H0.666667V6.66667H2.66667V9.66667H0.666667V10.6667H2.66667V12.1667C2.66697 12.4318 2.77243 12.686 2.9599 12.8734C3.14737 13.0609 3.40154 13.1664 3.66667 13.1667H5.16667V15.1667H6.16667V13.1667H9.16667V15.1667H10.1667V13.1667H11.6667C11.9318 13.1663 12.1859 13.0608 12.3734 12.8734C12.5608 12.6859 12.6663 12.4318 12.6667 12.1667V10.6667H14.6667V9.66667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1667 10.6667H5.16667V5.66667H10.1667V10.6667ZM6.16667 9.66667H9.16667V6.66667H6.16667V9.66667Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 6.66667H14.1667C14.1651 5.34106 13.6378 4.07019 12.7005 3.13284C11.7631 2.1955 10.4923 1.66821 9.16667 1.66667V0.666667C10.7574 0.6684 12.2825 1.3011 13.4074 2.42594C14.5322 3.55078 15.1649 5.0759 15.1667 6.66667Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 6.66667H11.6667C11.6659 6.00387 11.4022 5.36843 10.9336 4.89976C10.4649 4.43109 9.82947 4.16745 9.16667 4.16667V3.16667C10.0946 3.16779 10.9842 3.5369 11.6403 4.19304C12.2964 4.84917 12.6655 5.73875 12.6667 6.66667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReaderSignal);
export default __webpack_public_path__ + "static/media/ic-reader-signal.6d253322cde25f8d2a3d2d1e1cc22c93.svg";
export { ForwardRef as ReactComponent };